import axiosIns from '@/libs/axios'

const ROOT_URL = '/signal-automation'

export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    detail: null,
    runs: [],
    decisions: [],
    loading: false,
    detailLoading: false,
    dataSave: { message: null, status: null },
  },
  getters: {
    dataList: s => s.dataList,
    metaData: s => s.metaData,
    detail: s => s.detail,
    runs: s => s.runs,
    decisions: s => s.decisions,
    loading: s => s.loading,
    detailLoading: s => s.detailLoading,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_DETAIL(state, data) { state.detail = data },
    SET_RUNS(state, data) { state.runs = data },
    SET_DECISIONS(state, data) { state.decisions = data },
    SET_LOADING(state, val) { state.loading = val },
    SET_DETAIL_LOADING(state, val) { state.detailLoading = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data || [])
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
          commit('SET_LOADING', false)
          return response.data.data || []
        })
        .catch(error => {
          console.error(error)
          commit('SET_LOADING', false)
          commit('SET_DATA_SAVE', { status: false, message: 'Sinyal otomasyon kuralları alınamadı.' })
          return []
        })
    },
    detail({ commit }, id) {
      commit('SET_DETAIL_LOADING', true)
      return axiosIns.get(`${ROOT_URL}/${id}`)
        .then(response => {
          commit('SET_DETAIL', response.data.data)
          commit('SET_DETAIL_LOADING', false)
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          commit('SET_DETAIL_LOADING', false)
          commit('SET_DATA_SAVE', { status: false, message: 'Kural detayı alınamadı.' })
          throw error
        })
    },
    create({ commit, dispatch }, body) {
      return axiosIns.post(`${ROOT_URL}/create`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Sinyal otomasyon kuralı oluşturuldu.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Oluşturma başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    update({ commit, dispatch }, { id, body }) {
      return axiosIns.patch(`${ROOT_URL}/${id}`, body)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: 'Sinyal otomasyon kuralı güncellendi.' })
          return dispatch('getDataList', {}).then(() => response.data.data)
        })
        .catch(error => {
          console.error(error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Güncelleme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    remove({ commit, dispatch }, id) {
      return axiosIns.delete(`${ROOT_URL}/${id}`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message || 'Kural arşivlendi.' })
          dispatch('getDataList', {})
          return response.data.data
        })
        .catch(error => {
          console.error(error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Silme başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    setEnabled({ commit, dispatch }, { id, enabled }) {
      return axiosIns.patch(`${ROOT_URL}/${id}/enabled`, { enabled })
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message || 'Kural durumu güncellendi.' })
          return dispatch('getDataList', {}).then(() => response.data.data)
        })
        .catch(error => {
          console.error(error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Durum güncellenemedi.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    getRuns({ commit }, id) {
      return axiosIns.get(`${ROOT_URL}/${id}/runs`)
        .then(response => {
          commit('SET_RUNS', response.data.data || [])
          return response.data.data || []
        })
        .catch(error => {
          console.error(error)
          commit('SET_RUNS', [])
          return []
        })
    },
    getDecisions({ commit }, id) {
      return axiosIns.get(`${ROOT_URL}/${id}/decisions`)
        .then(response => {
          commit('SET_DECISIONS', response.data.data || [])
          return response.data.data || []
        })
        .catch(error => {
          console.error(error)
          commit('SET_DECISIONS', [])
          return []
        })
    },
    applyAdaptiveTpSl({ commit, dispatch }, id) {
      return axiosIns.post(`${ROOT_URL}/${id}/adaptive-tp-sl/apply`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message || 'Adaptif TP/SL uygulandı.' })
          return dispatch('getDataList', {}).then(() => response.data.data)
        })
        .catch(error => {
          console.error(error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Adaptif TP/SL uygulanamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
    executeCloseDecision({ commit, dispatch }, { ruleId, decisionId, body }) {
      return axiosIns.post(`${ROOT_URL}/${ruleId}/decisions/${decisionId}/execute-close`, body || {})
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message || 'Close kararı işlendi.' })
          return dispatch('getDecisions', ruleId).then(() => response.data.data)
        })
        .catch(error => {
          console.error(error)
          const msg = (error.response && error.response.data && error.response.data.message) || 'Close kararı çalıştırılamadı.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
          throw error
        })
    },
  },
}
